/**
 *  {
	"messageType": "alertNotification",
	"notificationId": 1645474586667,
	"notificationDetails": {"updateType":"SETUP_FILTERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"startHour":10,"startMinute":2,"endHour":3,"endMinute":3},"triggerPrice":0.0,"tradeDirection":null,"tacticName":"TIME_OF_DAY","symbol":"xyz"},
	"date": "2022-02-21T15:16:27.344-0500",
	"timestamp": "1645474587348"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) startHour
 * 2) startMinute
 * 3) endHour
 * 4) endMinute
 */
export function timeOfDayParser(pluginTemplate) {
    const parsedObject = {
        startHour: null,
        startMinute: null,
        endHour: null,
        endMinute: null,
    }
    if(pluginTemplate) {
        parsedObject.startHour=pluginTemplate.startHour;
        parsedObject.startMinute=pluginTemplate.startMinute;
        parsedObject.endHour=pluginTemplate.endHour;
        parsedObject.endMinute=pluginTemplate.endMinute;
    }
    return parsedObject;
}